import { Component, effect, inject } from '@angular/core';
import { FencePreviewResumeGroup } from '../models/fence-preview-resume-group';
import { FencePreviewFacadeService } from '../services/fence-preview.facade.service';
import { Guid } from 'guid-typescript';

@Component({
  selector: 'ng-fence-preview-resume',
  templateUrl: './fence-preview-resume.component.html',
  styleUrl: './fence-preview-resume.component.scss',
})
export class FencePreviewResumeComponent {
  private readonly fencePreviewFacadeService = inject(FencePreviewFacadeService);

  /**
   * Liste permettant de connaitre quel élément sont
   * @private
   */
  private groupsLoaded = new Map<Guid, boolean>();

  /**
   * En chargement si tous les groupes ne sont pas chargés
   * @protected
   */
  protected get loading(): boolean {
    return this.groupsLoaded.size === 0 || Array.from(this.groupsLoaded.values()).some(isLoaded => !isLoaded);
  }

  constructor() {
    effect(() => {
      const resumeGroups = this.fencePreviewFacadeService.resumeGroups();

      if (resumeGroups.length === 0) {
        return;
      }

      this.groupsLoaded.clear();

      resumeGroups.forEach(group => {
        this.groupsLoaded.set(group.id, false);
      });
    });
  }

  protected get resumeGroups(): FencePreviewResumeGroup[] {
    return this.fencePreviewFacadeService.resumeGroups();
  }

  protected get differentHeights(): number[] {
    return this.fencePreviewFacadeService.differentHeights();
  }

  /**
   * Met à jour le statut de chargement d'un groupe
   * @param resumeGroup
   * @protected
   */
  protected onGroupLoaded(resumeGroup: FencePreviewResumeGroup) {
    this.groupsLoaded.set(resumeGroup.id, true);
  }
}
